export default __webpack_public_path__ + "static/media/quantisal_step2.fad010f2.png";